export default {
    name: 'ContentBox',
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        tooltipText: {
            type: String,
            default: ''
        },
        tooltipClassSelector: {
            type: String,
            default: ''
        },
        loader: {
            type: Boolean,
            default: false
        },
        seeMoreFunction: {
            type: Function,
            required: false
        }
    },
    data: () => ({}),
    computed: {
        hasSeeMoreFunction() {
            return this.seeMoreFunction !== undefined && this.seeMoreFunction !== null;
        }
    },
    async created() {},
    methods: {}
};
